/**
 * 外国人データ取得API
 */
import { apiGet } from './client';

/**
 * 月別外国人ランキングを取得
 * @param {Object} params - リクエストパラメータ
 * @param {number} params.month - 月
 * @param {string} params.year - 年
 * @param {number} params.top_n - 上位n件
 * @param {AbortSignal} signal - キャンセル用のシグナル
 * @returns {Promise<Object>} 月別ランキングデータ
 */
export async function getMonthlyRanking(params, signal) {
  return apiGet('/api/foreigners/monthly-ranking', params, { signal });
}

/**
 * 年間外国人分布を取得
 * @param {Object} params - リクエストパラメータ
 * @param {string} params.year - 年
 * @param {number} params.top_n - 上位n件
 * @param {AbortSignal} signal - キャンセル用のシグナル
 * @returns {Promise<Object>} 年間分布データ
 */
export async function getYearlyDistribution(params, signal) {
  return apiGet('/api/foreigners/yearly-distribution', params, { signal });
}
